import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import logo from '../media/logo.svg';
import userDetailsIcon from '../media/icons/user-details.svg';
import usersIcon from '../media/icons/users.svg';
// import userIcon from '../media/icons/user.svg';
import reportsIcon from '../media/icons/reports-g.svg';
import userDetailsCloseIcon from '../media/icons/user-details-close.svg';
import logoutIcon from '../media/icons/logout-a.svg';

const NavBar = ({ onLogout, userDetail }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [userDetailOpen, setUserDetailOpen] = useState(false);

  const handleNavigation = useCallback((loc) => {
    navigate(loc);
    setUserDetailOpen(false);
  }, []);

  return (
    <>
      <div className="aboslute">
        <button
          className="z-50 ml-[5px] mr-[5px] float-right bg-white drop-shadow-md w-[50px] h-[50px] flex relative top-[25px] right-[15px] rounded-[3px]"
          onClick={() => setUserDetailOpen(true)}
          type="button"
        >
          <img className="m-auto" src={userDetailsIcon} alt="" />
        </button>
        <div className="z-50 ml-[5px] mr-[5px] float-right drop-shadow-md relative top-[25px] right-[25px] rounded-[3px]">
          <img className="w-[50px] h-[50px] " src={logo} alt="" />
        </div>
      </div>
      {userDetailOpen && (
        <div className="w-[285px] fixed right-0 top-0 z-[60] bg-white h-dvh drop-shadow-md">
          <div className="w-full h-full">
            <div className="px-4 pb-4 pt-6 h-[90px]">
              <button
                onClick={() => setUserDetailOpen(false)}
                type="button"
                className="float-right"
              >
                <img className="w-[50px] h-[50px]" src={userDetailsCloseIcon} alt="" />
              </button>
            </div>
            <div className="my-2 p-4">
              <span className="block text-lg">{userDetail.name}</span>
              <span className="text-[#434C58]/60 text-base text-wrap wrap-break-word">
                {userDetail.email}
              </span>
            </div>
            <div>
              {/* {userDetail.role === 'installer' && (
                <button
                  type="button"
                  onClick={() => handleNavigation('/users')}
                  className="text-lg w-full mr-[5px] p-4 flex text-[#323A45] border-b-[1px] border-solid border-[#E7E7E7]"
                >
                  <img className="w-[17px] mr-4" src={userIcon} alt="" />
                  {t('nav.user_management')}
                </button>
              )} */}
              {userDetail.role === 'commander' && (
                <button
                  type="button"
                  onClick={() => handleNavigation('/projects')}
                  className="text-lg w-full mr-[5px] p-4 flex text-[#323A45]"
                >
                  <img className="w-[17px] mr-4" src={usersIcon} alt="" />
                  {t('nav.project_management')}
                </button>
              )}
              {userDetail.role === 'commander' && (
                <button
                  type="button"
                  onClick={() => handleNavigation('/reports')}
                  className="text-lg w-full mr-[5px] p-4 flex text-[#323A45] border-t-[1px] border-b-[1px] border-solid border-[#E7E7E7]"
                >
                  <img className="w-[17px] mr-4" src={reportsIcon} alt="" />
                  {t('nav.reports')}
                </button>
              )}
              <button
                type="button"
                onClick={onLogout}
                className="text-lg w-full mr-[5px] p-4 flex text-[#323A45]"
              >
                <img className="w-[17px] mr-4 opacity-60" src={logoutIcon} alt="" />
                {t('nav.log_out')}
              </button>
            </div>
            <div className="text-lg fixed bottom-0 p-4 text-[#434C58]/60">
              {t('nav.version')}: {process.env.REACT_APP_VERSION || process.env.npm_package_version}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavBar;
